var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AddStar, CopySelectedEntries, DeleteSelectedEntries, DownloadEntries, OpenDialog, OpenFilePreview, RemoveStar } from '../../state/actions/commands';
import { ShareDialogComponent } from '../../sharing/share-dialog/share-dialog.component';
import { ShareLinkDialogComponent } from '../../sharing/share-link-dialog/share-link-dialog.component';
import { CrupdateFolderDialogComponent } from '../../folders/components/crupdate-folder-dialog/crupdate-folder-dialog.component';
import { MoveEntriesDialogComponent } from '../../entries/move-entries-dialog/move-entries-dialog.component';
import { RenameEntryDialogComponent } from '../../entries/rename-entry-dialog/rename-entry-dialog.component';
import { DriveContextActions } from '../drive-context-actions';
import { DriveState } from '../../state/drive-state';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
var noopTrue = function () { return true; };
var ɵ0 = noopTrue;
var EntryActions = /** @class */ (function (_super) {
    __extends(EntryActions, _super);
    function EntryActions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.actions = [
            {
                viewName: 'Preview',
                icon: 'visibility',
                showInCompact: true,
                execute: function () {
                    _this.store.dispatch(new OpenFilePreview());
                },
                visible: function () {
                    return !_this.onlyFoldersSelected;
                },
            },
            {
                viewName: 'Manage People',
                icon: 'person-add',
                showInCompact: true,
                execute: function () {
                    _this.store.dispatch(new OpenDialog(ShareDialogComponent, null, 'share-dialog-container'));
                },
                visible: noopTrue,
            },
            {
                viewName: 'Get shareable link',
                icon: 'link',
                execute: function () {
                    _this.store.dispatch(new OpenDialog(ShareLinkDialogComponent, null, {
                        panelClass: 'share-link-dialog-container',
                        autoFocus: false,
                    }));
                },
                visible: function () { return !_this.multipleEntriesSelected; }
            },
            {
                viewName: 'Add a star',
                icon: 'star',
                execute: function () {
                    _this.store.dispatch(new AddStar(_this.getSelectedEntries()));
                },
                visible: function () { return !_this.allStarred; }
            },
            {
                viewName: 'Remove star',
                icon: 'star-border',
                execute: function () {
                    _this.store.dispatch(new RemoveStar(_this.getSelectedEntries()));
                },
                visible: function () { return _this.allStarred; }
            },
            {
                viewName: 'New Folder',
                icon: 'create-new-folder',
                execute: function () {
                    _this.store.dispatch(new OpenDialog(CrupdateFolderDialogComponent, null, 'crupdate-folder-dialog-container'));
                },
                visible: function () {
                    var folderIsSelected = _this.store.selectSnapshot(DriveState.selectedFolderId);
                    return !_this.multipleEntriesSelected && !!folderIsSelected;
                }
            },
            {
                viewName: 'Move to',
                icon: 'subdirectory-arrow-right',
                execute: function () {
                    _this.store.dispatch(new OpenDialog(MoveEntriesDialogComponent, null, 'move-entries-dialog-container'));
                },
                visible: noopTrue,
            },
            {
                viewName: 'Rename',
                icon: 'edit',
                execute: function () {
                    _this.store.dispatch(new OpenDialog(RenameEntryDialogComponent, null, 'rename-entry-dialog-container'));
                },
                visible: function () { return !_this.multipleEntriesSelected; }
            },
            {
                viewName: 'Make a copy',
                icon: 'content-copy',
                execute: function () {
                    _this.store.dispatch(new CopySelectedEntries());
                },
                visible: noopTrue,
            },
            {
                viewName: 'Download',
                icon: 'file-download',
                separatorAfter: true,
                execute: function () {
                    _this.store.dispatch(new DownloadEntries());
                },
                visible: noopTrue,
            },
            {
                viewName: 'Delete',
                icon: 'delete',
                showInCompact: true,
                execute: function () {
                    _this.store.dispatch(new DeleteSelectedEntries());
                },
                visible: noopTrue,
            },
        ];
        return _this;
    }
    EntryActions.ngInjectableDef = i0.defineInjectable({ factory: function EntryActions_Factory() { return new EntryActions(i0.inject(i1.Store)); }, token: EntryActions, providedIn: "root" });
    return EntryActions;
}(DriveContextActions));
export { EntryActions };
export { ɵ0 };
